import { useMaintenanceMode } from "@/features/maintenance/hooks";
import { MAINTENANCE_MESSAGE } from "@/lib/maintenance";

/**
 * Site-wide maintenance notice. Renders only while the window is open.
 *
 * Reads the same query the root route guard resolves, and the root route seeds
 * it during SSR, so the server-rendered HTML and the hydrated page always agree.
 * Rendered at the very top of the page, above the sticky header, so it reads as
 * a platform-level status message rather than page content.
 */
export function MaintenanceBanner() {
  if (!useMaintenanceMode()) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="relative z-[55] border-b border-[#f6821f]/25 bg-[#f6821f]/[0.07]"
    >
      <div className="mx-auto flex max-w-[1440px] flex-wrap items-center justify-center gap-x-3 gap-y-1 px-6 py-2.5 text-center md:px-8">
        <span className="flex items-center gap-2">
          <span className="relative flex h-1.5 w-1.5 shrink-0">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#f6821f] opacity-70 motion-reduce:hidden" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[#f6821f]" />
          </span>
          <span className="font-mono-hb text-[10px] font-medium uppercase tracking-[0.18em] text-[#f6821f]">
            Maintenance
          </span>
        </span>
        <span aria-hidden="true" className="hidden h-3 w-px bg-[#f6821f]/25 sm:block" />
        <p className="font-hb text-[13px] leading-snug text-[#e8e8e8]">{MAINTENANCE_MESSAGE}</p>
      </div>
    </div>
  );
}
